module.exports = __webpack_public_path__ + "static/img/banner08.1dc0196d.png";